import { Box, Button, Dialog, DialogContent, FormControl, FormLabel, TextField, Typography } from '@mui/material';
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from '../../../app/core/state/hooks';
import {
    darkGreenColor,
    emptyString,
    greenColor,
    isTaskDialog,
    lightGrayColor,
    whiteColor
} from "../../constants/constants";
import { closeSaveDialog } from "../../core/state/dialogs/saveTaskTagDialogSlice";
import { editTag, editTask, fetchTags, fetchTasks, saveTag, saveTask } from "../../core/state/tasksTags/tasksTagsSlice";

export default function SaveTaskTagDialog() {
    const dispatch = useAppDispatch();
    const { isOpen: dialogIsOpen, dialogType, isEditing, selectedData } = useAppSelector((state) => state.saveTaskTagDialog);
    const [taskTagName, setTaskTagName] = useState("");

    const confirmationMessage = dialogType === isTaskDialog ? 'Edición tarea' : 'Edición de tag';

    const closeDialog = () => {
        setTaskTagName("");
        dispatch(closeSaveDialog());
    };

    const handleSave = () => {
        if (taskTagName === emptyString) return;
        
        closeDialog();
        
        if (isEditing) {
            if (dialogType === isTaskDialog) {
                dispatch(editTask({ id: selectedData.task.id || 0, name: taskTagName }))
                    .then(() => dispatch(fetchTasks()));
            } else {
                dispatch(editTag({ id: selectedData.tag.id, name: taskTagName }))
                    .then(() => dispatch(fetchTags()));
            }
        } else {
            if (dialogType === isTaskDialog) {
                dispatch(saveTask(taskTagName)).then(() => dispatch(fetchTasks()));
            } else {
                dispatch(saveTag(taskTagName)).then(() => dispatch(fetchTags()));
            }
        }
    };

    useEffect(() => {
        if (isEditing) {
            if (dialogType === isTaskDialog) {
                setTaskTagName(selectedData.task.name ?? emptyString);
            } else {
                setTaskTagName(selectedData.tag.name ?? emptyString);
            }
        }
    }, [isEditing, dialogIsOpen, dialogType, selectedData.task.name, selectedData.tag.name]);

    return (
        <Dialog open={dialogIsOpen} onClose={closeDialog} fullWidth maxWidth="xs">
            <Box sx={{ p: 2 }}>
                <DialogContent sx={{ display: "flex", flexDirection: "row" }}>
                    <Typography variant='h6' sx={{ borderBottom: 2, borderBottomColor: 'rgba(35, 31, 32, 0.1)', pb: 1, flex: 1 }}>
                        {confirmationMessage}
                    </Typography>
                </DialogContent>
                <DialogContent sx={{ display: "flex", flexDirection: "row" }}>
                    <FormControl fullWidth>
                        <FormLabel sx={{ mb: 1 }}>Nombre</FormLabel>
                        <TextField
                            id="taskTagName"
                            sx={{ backgroundColor: lightGrayColor, borderRadius: 2, border: 2, borderColor: lightGrayColor }}
                            value={taskTagName}
                            required
                            onChange={(event) => setTaskTagName(event.target.value)}
                        />
                    </FormControl>
                </DialogContent>
                <DialogContent>
                    <Button 
                        sx={{ 
                            backgroundColor: greenColor, 
                            color: whiteColor, 
                            width: 120, 
                            '&:hover': { backgroundColor: darkGreenColor } 
                        }}
                        onClick={handleSave}
                    >
                        Guardar
                    </Button>
                </DialogContent>
            </Box>
        </Dialog>
    );
}